import type { IApplyCampaignToCartMutation } from "@jti/magento";
import { magento } from "@jti/magento";

import { TAGS } from "../common/tags";
import { convertApiError } from "../convertApiError";
import type { LoyaltyApiBuilder } from "../loyaltyApi.types";

export type ApplyLoyaltyCampaignEndpointArgs = {
  cartId: string;
  campaign_uuid: string;
};

export type ApplyLoyaltyCampaignEndpointResponse = IApplyCampaignToCartMutation;

export const applyLoyaltyCampaignEndpoint = (builder: LoyaltyApiBuilder) => ({
  applyLoyaltyCampaign: builder.mutation<ApplyLoyaltyCampaignEndpointResponse, ApplyLoyaltyCampaignEndpointArgs>({
    queryFn: async ({ cartId, campaign_uuid }) => {
      try {
        const data = await magento.applyCampaignToCart(cartId, campaign_uuid);
        return { data };
      } catch (error: unknown) {
        return convertApiError(error);
      }
    },
    invalidatesTags: [TAGS.LOYALTY_POINTS, TAGS.LOYALTY_VOUCHERS],
  }),
});
